import React, {useState, useCallback, useEffect} from 'react';
import AutomationParameterDropdowns from 'components/automation/AutomationParameterDropdowns.js';
import {getParameterName} from 'utils/getParameterName.js';
import StepActions from './StepActions.js';
import Modes from './Modes.js';
import {MODE_TO_HEIGHT, WAVEFORM, PIANO_ROLL, INFO} from 'constants/arrangement-modes.js';
import {getParametersWithAutomation} from 'parameters/getParametersWithAutomation.js';
import {MACROS_EFFECT} from 'effects/live/constants.js';
import Dropdown from 'react-dropdown';
import { connect } from "react-redux";
import {INSTRUMENT_RACK} from 'constants/track-types.js';
import {
    setArrangementBottomMode,
    setArrangementBottomResizing,
    setBottomToolbarOffset,
    setShowAutomation,
    setShowPianoRoll,
    setArrangementBottomHeight,
    setTrackAutomationParameter,
    setTrackAutomationRackDevice,
    setTrackAutomationDevice,
    setTrackAutomationSubDevice,
       } from 'actions/index.js';
import Colors from 'components/Colors.js';
const colors = new Colors();
const DOUBLE_CLICK_TIME = 300;
const MIN_HEIGHT = 50;

function AutomationToolbar(props) {
    let {track, selectedDevice, subDevice, selectedParameter, selectedRackDevice} = props;
   let parametersWithAutomation = getParametersWithAutomation(track);

    useEffect(() => {
        if (props.hideAutomation) {
            props.setShowAutomation(false);
        }
    }, [props.hideAutomation]);

    /**
     * Device -> Sub Device -> Parameter
     * Rack -> Device -> Sub Device -> Parameter
     */
    const onParameterClicked = useCallback((e, parameter) =>  {
        e.stopPropagation();
        if (props.showAutomation && parameter === selectedParameter) {
            return props.setShowAutomation(false);
        }
        props.setShowAutomation(true);
        props.setTrackAutomationParameter(parameter);
    }, [
        selectedParameter,
        props.setTrackAutomationDevice,
        props.setTrackAutomationRackDevice,
        props.showAutomation
    ]);
                                          
    const [lastClick, setLastClick] = useState(undefined);
    const onMouseDown = useCallback((e) => {
        let el = document.getElementsByClassName("toolbar-resizer")[0];
        let y = e.clientY - el.getBoundingClientRect().top;

        props.setBottomOffset(y);
        props.setArrangementBottomResizing(true);
        // props.setArrangmentBottomResizingOffset(e.clientX);
        let now = new Date().getTime();
        if (lastClick !== undefined) {
            if (now - lastClick <= DOUBLE_CLICK_TIME) {
                if (props.hide) {
                    return props.hide();
                }
                if (props.sequencerEngine.store.getState().arrangement.bottomHeight <= MIN_HEIGHT) {
                    props.setArrangementBottomHeight(MODE_TO_HEIGHT[PIANO_ROLL]);
                } else {
                    props.setShowPianoRoll(false);
                }
            }
        }
        setLastClick(now);
    }, [lastClick, setLastClick]);

    const automationIcon = props.showAutomation ?
          "/automation-icon-enabled.png" : 
          "/automation-icon-disabled.png";
    const dropdownClassName = props.showAutomation ?
          "dropdowns" : "dropdowns disabled";

    let color = colors.getColorForTrack(props.track);
    let style ={
    };

    if (props.bottomMode !== PIANO_ROLL && !props.hideAutomation) {
        // then we shouldn't show those dropdowns, just a basic ass toolbar
        return (
            <div
              style={style}
              className="automation-toolbar">
              <div className="toolbar-container">
                <Modes id={props.id} track={track}/>
                <div
                  onMouseDown={onMouseDown}
                  onMouseUp={() => props.setArrangementBottomResizing(false)}
                  className="toolbar-resizer"
                >
                  <div
                    onMouseDown={(e) => {
                        e.stopPropagation();
                        if (props.hide) {
                            props.hide();
                        } else {
                            props.setShowPianoRoll(false);
                        }
                        props.setArrangementBottomResizing(false);
                    }}
                    className="collapse-toggle bottom-shower">
                    <div className="arrow-down">
                    </div>
                  </div>
                </div>
              </div>
            </div>
        );
    }

    let toggleContent = (
        <div
          onMouseDown={(e) => {
              e.stopPropagation();
              if (props.hide) {
                  props.hide();
              } else {
                  props.setShowPianoRoll(false);
              }
              props.setArrangementBottomResizing(false);
          }}
          className="bottom-shower collapse-toggle">
                <div className="arrow-down"/>
        </div>);
    
    return (
        <div
          style={style}
          className="automation-toolbar">
          <div className="toolbar-container">
             <Modes id={props.id} track={track}/>
            <div
              onMouseDown={onMouseDown}
              onMouseUp={() => props.setArrangementBottomResizing(false)}
              className="toolbar-resizer"
            >
              {!props.hideAutomation ? toggleContent : ''}
            </div>
          </div>
          <div className="toolbar-container rest-toolbar">
            {!props.hideAutomation ? 
            <AutomationParameterDropdowns track={track} sequencerEngine={props.sequencerEngine}/>
             : ''}
            {!props.hideAutomation ? 
             <img
                className="automation-icon"
                src={automationIcon} onClick={() => props.setShowAutomation(!props.showAutomation)}/>
             : ''}
              <div
                onMouseDown={onMouseDown}
                onMouseUp={() => props.setArrangementBottomResizing(false)}
                className="toolbar-resizer automation-parameters"
                >
                {parametersWithAutomation.map(
                    parameter =>
                        <div
                          onMouseDown={(e) => onParameterClicked(e, parameter)}
                          style={props.showAutomation && selectedParameter === parameter ?
                                 {
                                     backgroundColor: color,
                                     color: 'black'} :
                                 {}}
                          className="parameter-button">{getParameterName(parameter)}</div>)}
              </div>
            <StepActions color={color} track={track}/>
            {props.hideAutomation ? toggleContent : ''}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    if (props.track) {
        let track = props.track;
        if (track && track.tracks && track.tracks[0]) {
            track = track.tracks[0].track;
        }

        return {
            id: track === undefined ? 0 :
                track.sample !== undefined && track.sample.getId() !== undefined ?
                track.sample.getId() : track.presetName || track.getName(),
            numEffects: props.track.effects && props.track.effects.length,
            selectedDevice: state.automation.trackDevice[props.track.id],
            subDevice: state.automation.trackSubDevice[props.track.id],
            selectedParameter: state.automation.trackParameter[props.track.id],
            showAutomation: state.automation.show,
            selectedRackDevice: state.automation.trackRackDevice[props.track.id],
            selectedInstrument: state.tracks.selectedRackSubTrack[props.track.id],
            bottomMode: state.arrangement.bottomMode
        };
    }
    return {};
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setTrackAutomationParameter: (parameter) =>
            dispatch(setTrackAutomationParameter(props.track.id, parameter)),
        setShowPianoRoll: (show) =>
            dispatch(setShowPianoRoll(show)),
        setTrackAutomationDevice: (device) =>
            dispatch(setTrackAutomationDevice(props.track.id, device)),
        setTrackAutomationRackDevice: (device) =>
            dispatch(setTrackAutomationRackDevice(props.track.id, device)),
        setTrackAutomationSubDevice: (device) =>
            dispatch(setTrackAutomationSubDevice(props.track.id, device)),
        setArrangementBottomResizing: (resizing) =>
            dispatch(setArrangementBottomResizing(resizing)),
        setArrangementBottomHeight: (height) =>
            dispatch(setArrangementBottomHeight(height)),
        setShowAutomation: (show) =>
            dispatch(setShowAutomation(show)),
        setBottomMode: (bottomMode) =>
            dispatch(setArrangementBottomMode(bottomMode)),
        setBottomOffset: (bottomOffset) =>
            dispatch(setBottomToolbarOffset(bottomOffset))
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(AutomationToolbar);
